import wincomb from './wincomb';

const startBalance = 5000;

const serverManager = {
  init({
    winTable, scatter, freeSpinsMulti, freeSpinsAmount,
  }) {
    this.winTable = winTable;
    this.scatter = scatter;
    this.freeSpinsMulti = freeSpinsMulti;
    this.freeSpinsAmount = freeSpinsAmount;

    this.balance = startBalance;
    this.win = 0;
    this.freeSpins = 0;
    this.freeSpinsDone = 0;

    return Promise.resolve({ balance: this.balance });
  },

  addEventListener() {},

  isBigWin(spinWin, scatterLength) {
    if (scatterLength > 2 && Math.random() < 0.5) {
      return true;
    }

    const win = this.freeSpins > this.freeSpinsDone ? spinWin * this.freeSpinsMulti : spinWin;
    const bigWin = win && this.balance + this.balance + this.win + win > startBalance * 1.05;

    return (+!!win * 0.68) + (+bigWin * 0.25) > Math.random();
  },

  play({ bet, lines }) {
    const symbols = this.getSymbols();
    const comb = wincomb.getWin(symbols, lines);
    let scatterWin = comb.scatterWin * bet * lines;
    let spinWin = (comb.linesWin * bet) + scatterWin;

    if (this.isBigWin(spinWin, comb.scatterLength)) {
      return this.play({ bet, lines });
    }

    if (this.freeSpins > this.freeSpinsDone) {
      spinWin *= this.freeSpinsMulti;
      scatterWin *= this.freeSpinsMulti;
      this.win += spinWin;
      this.freeSpinsDone += 1;
    } else {
      this.balance -= bet * lines;
      this.win = spinWin;
      this.freeSpins = 0;
      this.freeSpinsDone = 0;
    }

    if (comb.scatterLength > 2) {
      this.freeSpins += this.freeSpinsAmount;
    }

    return Promise.resolve({
      win: this.win,
      spinWin,
      scatterWin,
      freeSpins: this.freeSpins,
      freeSpinsDone: this.freeSpinsDone,
      balance: this.balance,
      lines: comb.lines,
      symbols,
    });
  },

  playDouble() {
    this.win = Math.random() > 0.55 ? this.win * 2 : 0;
    return Promise.resolve({ win: this.win });
  },

  finish() {
    this.balance += this.win;
    this.win = 0;

    return Promise.resolve(this.balance);
  },

  getSymbols() {
    const symbols = Array.from({ length: 15 }, () =>
      Math.floor(Math.random() * this.winTable.length));

    return this.checkSymbols(symbols) ? symbols : this.getSymbols();
  },

  checkSymbols(symbols) {
    return symbols.reduce((acc, symbol, i) => {
      if (symbol === this.scatter) {
        acc[i % 5] += 1;
      }
      return acc;
    }, [0, 0, 0, 0, 0]).reduce((acc, curr) => acc && curr < 2, true);
  },
};

export default serverManager;



// WEBPACK FOOTER //
// ../base/js/managers/fake-server.js